import {
  FileAudioIcon,
  FileExcelIcon,
  FileImageIcon,
  FilePdfIcon,
  FilePowerpointIcon,
  FileSvgIcon,
  FileTxtIcon,
  FileVideoIcon,
  FileWordIcon,
  FileZipIcon,
  FileExternalIcon
} from "components/Base";

import * as R from "ramda";

import { isEmptyOrNil } from "utils/General";

export const getFileIconAndExtension = fileName => {
  if (isEmptyOrNil(fileName)) {
    return {
      icon: FileExternalIcon,
      extension: "file_icon.png",
      name: "file_icon"
    };
  }

  const name = R.pipe(R.split("."), R.head)(fileName);
  const extension = R.pipe(R.toUpper, R.split("."), R.last)(fileName);

  const EXTENSION_MAP = {
    PDF: FilePdfIcon,
    ZIP: FileZipIcon,
    DOC: FileWordIcon,
    DOCX: FileWordIcon,
    PPT: FilePowerpointIcon,
    PPTX: FilePowerpointIcon,
    SVG: FileSvgIcon,
    MP3: FileAudioIcon,
    WAV: FileAudioIcon,
    MP4: FileVideoIcon,
    AVI: FileVideoIcon,
    JPG: FileImageIcon,
    JPEG: FileImageIcon,
    PNG: FileImageIcon,
    XLS: FileExcelIcon,
    XLSX: FileExcelIcon,
    TXT: FileTxtIcon
  };
  const icon = EXTENSION_MAP[extension] || FileExternalIcon;
  return { icon, extension, name };
};

export const getIconByMimeType = mimeType => {
  if (isEmptyOrNil(mimeType)) {
    return null;
  }

  if (mimeType === "external") {
    return FileExternalIcon;
  }

  const EXTENSION_MAP = {
    "application/pdf": FilePdfIcon,
    "application/zip": FileZipIcon,
    "application/msword": FileWordIcon,
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": FileWordIcon,
    "application/vnd.ms-powerpoint": FilePowerpointIcon,
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": FilePowerpointIcon,
    "image/svg+xml": FileSvgIcon,
    "audio/mpeg": FileAudioIcon,
    "audio/wav": FileAudioIcon,
    "audio/mp3": FileAudioIcon,
    "video/mp4": FileVideoIcon,
    "video/x-msvideo": FileVideoIcon,
    "image/jpeg": FileImageIcon,
    "image/png": FileImageIcon,
    "image/jpg": FileImageIcon,
    "image/gif": FileImageIcon,
    "image/webp": FileImageIcon,
    "image/heic": FileImageIcon,
    "application/vnd.ms-excel": FileExcelIcon,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": FileExcelIcon,
    "text/plain": FileTxtIcon
  };
  return EXTENSION_MAP[mimeType] || FileWordIcon;
};
